<template>
  <div v-if="isShowModuleModal" class="modal d-block" tabindex="-1" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header">
          <h5 class="modal-title">{{ isEditMode ? 'Edit Module' : 'Create Module' }}</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="closeModuleModal"></button>
        </div>

        <!-- Form Content -->
        <form @submit.prevent="handleSubmit">
          <div class="modal-body">
            <!-- Row 1: Module ID, Module Code, Module Name -->
            <div class="form-row form-row-3">
              <div class="form-group">
                <label class="form-label required">Module ID</label>
                <input
                  v-model="formData.moduleId"
                  type="text"
                  placeholder="e.g. MOD-INV"
                  class="form-input"
                />
                <span v-if="errors.moduleId" class="error-text">
                  {{ errors.moduleId }}
                </span>
              </div>

              <div class="form-group">
                <label class="form-label required">Module Code</label>
                <input
                  v-model="formData.moduleCode"
                  type="text"
                  placeholder="e.g. INV"
                  class="form-input"
                />
                <span v-if="errors.moduleCode" class="error-text">
                  {{ errors.moduleCode }}
                </span>
              </div>

              <div class="form-group">
                <label class="form-label required">Module Name</label>
                <input
                  v-model="formData.moduleName"
                  type="text"
                  placeholder="e.g. Inventory"
                  class="form-input"
                />
                <span v-if="errors.moduleName" class="error-text">
                  {{ errors.moduleName }}
                </span>
              </div>
            </div>

            <!-- Row 2: Display Order, Icon, Category -->
            <div class="form-row form-row-3">
              <div class="form-group">
                <label class="form-label">Display Order</label>
                <input
                  v-model.number="formData.displayOrder"
                  type="number"
                  placeholder="0"
                  class="form-input"
                />
                <span v-if="errors.displayOrder" class="error-text">
                  {{ errors.displayOrder }}
                </span>
              </div>

              <div class="form-group">
                <label class="form-label">Icon</label>
                <input
                  v-model="formData.icon"
                  type="text"
                  placeholder="e.g. fa-box"
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Category</label>
                <input
                  v-model="formData.category"
                  type="text"
                  placeholder="e.g. Operations"
                  class="form-input"
                />
              </div>
            </div>

            <!-- Row 3: Route, Version, Tags -->
            <div class="form-row form-row-3">
              <div class="form-group">
                <label class="form-label">Route</label>
                <input
                  v-model="formData.route"
                  type="text"
                  placeholder="e.g. /inventory"
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Version</label>
                <input
                  v-model.number="formData.version"
                  type="number"
                  placeholder="1"
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label class="form-label">Tags</label>
                <input
                  v-model="tagsInput"
                  type="text"
                  placeholder="comma, separated, tags"
                  class="form-input"
                />
              </div>
            </div>

            <!-- Description -->
            <div class="form-group">
              <label class="form-label">Description</label>
              <textarea
                v-model="formData.description"
                rows="2"
                placeholder="Short description of this module"
                class="form-input form-textarea"
              ></textarea>
            </div>

            <!-- Toggles -->
            <div class="form-group toggles-group">
              <label class="form-label">Settings</label>
              <div class="toggle-row">
                <label class="toggle-item">
                  <input type="checkbox" v-model="formData.isActive" />
                  <span>Active</span>
                </label>
                <label class="toggle-item">
                  <input type="checkbox" v-model="formData.isSystemModule" />
                  <span>System Module</span>
                </label>
                <label class="toggle-item">
                  <input type="checkbox" v-model="formData.tenantConfigurable" />
                  <span>Tenant Configurable</span>
                </label>
                <label class="toggle-item">
                  <input type="checkbox" v-model="formData.licenseRequired" />
                  <span>License Required</span>
                </label>
                <label class="toggle-item">
                  <input type="checkbox" v-model="formData.defaultEnabled" />
                  <span>Default Enabled</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="modal-footer">
            <button
              type="button"
              class="button button-secondary"
              @click="closeModuleModal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="button button-primary"
              :disabled="isSubmitting"
            >
              <span v-if="!isSubmitting">✓ {{ isEditMode ? 'Save Changes' : 'Create Module' }}</span>
              <span v-else>{{ isEditMode ? 'Saving...' : 'Creating...' }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script src="./Modulemodal.js"></script>

<style scoped>
* {
  box-sizing: border-box;
}

.form-group {
  margin-bottom: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-row-3 {
  grid-template-columns: repeat(3, 1fr);
}

.form-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  color: #014906;
  text-transform: none;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.form-label.required::after {
  content: ' *';
  color: #ef4444;
}

.form-input,
.form-select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
  color: #1f2937;
  background-color: #ffffff;
  font-family: inherit;
  transition: all 0.2s;
}

.form-textarea {
  resize: vertical;
  min-height: 48px;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #14b8a6;
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.1);
}

.form-input::placeholder {
  color: #9ca3af;
}

.error-text {
  display: block;
  font-size: 12px;
  color: #ef4444;
  margin-top: 6px;
}

.toggles-group .toggle-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
}

.toggle-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #374151;
  cursor: pointer;
  font-weight: 400;
  text-transform: none;
}

.toggle-item input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
  accent-color: #2e4a2fb8;
}

.button {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
}

.button-secondary {
  background-color: #ffffff;
  color: #374151;
  border: 1px solid #d1d5db;
}

.button-secondary:hover {
  background-color: #f9fafb;
  border-color: #9ca3af;
}

.button-primary {
  background-color: #797a7b;
  color: white;
}

.button-primary:hover:not(:disabled) {
  background-color: #0d9488;
  box-shadow: 0 4px 12px rgba(20, 184, 166, 0.3);
}

.button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.modal-title{
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
}
.modal-header{
  padding: 12px 18px;
  background-color: gray;
}
.modal-footer{
  padding: .45rem;
}
.btn-close{
color: #6B7280;
}
/* Responsive design */
@media (max-width: 768px) {
  .form-row-3 {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 640px) {
  .form-row,
  .form-row-3 {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>